var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mt-4 mb-0 body-1"},[_c('router-link',{attrs:{"to":{ name: 'GeneratePosterPage' }}},[_vm._v(" Générer votre affiche avec notre outil en ligne ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }